import {css, type Theme} from '@emotion/react';
import {configureFonts, getFontThemeList} from '@nfq/next-fonts';
import {createConfig} from '@nfq/react-grid';

import {globalCss, shadows, themeColors} from 'UI/utils/theme';

export const fontDefinitions = configureFonts({
    Montserrat: [
        {
            fontDisplay: 'swap',
            fontStyle: 'normal',
            fontWeight: '100 900',
            preload: true,
            src: '/fonts/Montserrat.woff2'
        },
        {
            fontDisplay: 'swap',
            fontStyle: 'italic',
            fontWeight: '100 900',
            preload: true,
            src: '/fonts/Montserrat-Italic.woff2'
        }
    ]
});

export const breakpoints = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'] as const;
export const {configType, globalCss: globalGridCss} = createConfig(breakpoints, {
    baseSpacing: 0.4,
    container: {
        lg: 'fluid',
        md: 'fluid',
        sm: 'fluid',
        xl: 1288,
        xs: 'fluid',
        xxl: 1288
    },
    containerPadding: {
        lg: 20,
        md: 20,
        sm: 10,
        xl: 20,
        xs: 10,
        xxl: 20
    }
});

export const theme: Theme = {
    boxShadows: shadows,
    colors: themeColors,
    fonts: getFontThemeList(fontDefinitions)
};

export const globals = css`
    ${globalCss}

    ${globalGridCss}

    *,
    &::before,
    &::after {
        box-sizing: border-box;
    }

    * {
        -webkit-tap-highlight-color: transparent;
    }

    html {
        display: flex;
        flex-direction: column;
        font-size: 10px;
        min-height: 100%;
        scroll-behavior: smooth !important;
        scroll-padding-top: 100px;
    }

    html, body {
        margin: 0;
        min-height: 100%;
        position: relative;
    }

    body {
        background-color: ${theme.colors.backgroundDark};
        color: ${theme.colors.textPrimary};
        font-family: ${theme.fonts.Montserrat};
        display: flex;
        flex: 1 2 auto;
        flex-direction: column;
        padding: 0;
    }

    #__next {
        display: flex;
        flex: 1 2 auto;
        flex-direction: column;
        min-height: 100%;
    }
`;